<template>
  <div class="session-wrapper">
    <v-container class="fill-height">
      <v-fade-transition>
        <v-row>
          <v-col align="center" align-content="center">
            <div class="blob text-center">
              <div class="display-2 text--title text--gradient">
                Cerrando sesión...
              </div>
            </div>
          </v-col>
        </v-row>
      </v-fade-transition>
    </v-container>
  </div>
</template>
<script>
import { SESSION_LOGOUT } from '@/store/actions.type'
export default {
  data() {
    return {
      isLoading: true
    }
  },
  mounted() {
    this.logout()
  },
  methods: {
    async logout() {
      await this.$store.dispatch(SESSION_LOGOUT)
      this.$router.push({ name: 'login' })
    }
  }
}
</script>
